import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {SelectInputDialogComponent} from './select-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectInputComponent extends FieldControlMaster implements OnInit {
  @Output() selectInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() selectInputDelete = new EventEmitter<number>();
  dialogComponent = SelectInputDialogComponent;
  placeholder = 'Sélectionner une valeur';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.placeholder = this.control.options.placeholder || this.placeholder;
  }
  onUpdatedControl(object) {
    this.selectInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.selectInputDelete.emit(index);
  }
}
